// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(min-width: 1600px){.h1[data-v-171a742c]{font-size:96px;line-height:106px}}[data-v-171a742c] .btn.btn-free-hero{display:flex;justify-content:center;align-items:center;width:64px;height:64px;border-radius:50%;font-size:24px;line-height:24px}@media(max-width: 767.98px){[data-v-171a742c] .btn.btn-free-hero{height:48px;width:48px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
